var e = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var o = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
var t = (r, n, u) => n in r ? e(r, n, { enumerable: !0, configurable: !0, writable: !0, value: u }) : r[n] = u, f = (r, n) => {
  for (var u in n || (n = {}))
    o.call(n, u) && t(r, u, n[u]);
  if (i)
    for (var u of i(n))
      a.call(n, u) && t(r, u, n[u]);
  return r;
};
function g(r, n) {
  return Array.isArray(r) ? [...r].reduce(
    (u, c) => f(f({}, u), g(c, n)),
    {}
  ) : typeof r == "function" ? r(n) : r == null ? {} : r;
}
export {
  g
};
